import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { CompanyPageLayout } from 'client-portal/components/PageLayout'
import { Container } from 'components/Layout'
import { ROUTES, COMPANY_ROUTES } from 'client-portal/constants/routes'
import { SessionDetail } from 'sharedComponents/SessionDetail'
import { GroupMemberRole, useAuth, CompanyMemberRole } from '@modmd/data'

interface RouterProps {
  testSessionId: string
  companyId: string
}

type Props = RouteComponentProps<RouterProps>

export const CompanyTestSessionDetails: React.FC<Props> = ({ match }) => {
  const { testSessionId, companyId } = match.params
  const { getUserCompaniesWithRole, getUserGroupsWithRole } = useAuth()
  const { hasCompaniesWithRole } = getUserCompaniesWithRole({
    roles: [CompanyMemberRole.Manager, CompanyMemberRole.Owner],
    companyIds: [companyId],
  })
  const { groups } = getUserGroupsWithRole({
    companyIds: [companyId],
    roles: [GroupMemberRole.Coordinator, GroupMemberRole.Manager],
  })

  const isCoordinator = groups.some(({ role }) => role === GroupMemberRole.Coordinator)
  const isAccessToSensitiveDataDenied = !hasCompaniesWithRole && isCoordinator

  return (
    <CompanyPageLayout>
      <Container>
        <SessionDetail
          testSessionId={testSessionId}
          goBackPath={`/${ROUTES.COMPANY}/${companyId}/${COMPANY_ROUTES.TEST_SESSIONS}`}
          isEditable
          isAddable={false}
          isDownloadCsvEnabled
          skipTest={isAccessToSensitiveDataDenied}
          onlyPermitted
          participantOnly
          columnLabels={{ paymentStatus: null }}
          isOrderVisible
        />
      </Container>
    </CompanyPageLayout>
  )
}
